import { render } from "./IzinSiswa.vue?vue&type=template&id=050bca78&scoped=true"
import script from "./IzinSiswa.vue?vue&type=script&lang=js"
export * from "./IzinSiswa.vue?vue&type=script&lang=js"

import "./IzinSiswa.vue?vue&type=style&index=0&id=050bca78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050bca78"]])

export default __exports__